import {studioScripts} from './pages/singleStudio';
import SnowQueen from './pages/snowQueen';
import Teacher from './pages/singleTeacher';
import TeacherList from './pages/listTeachers';
import ListSeminars from './pages/listSeminars';
import {contactScripts} from "./pages/contacts";
import Seminar from './pages/singleSeminar';
import Abonement from './pages/abonement';
import profilePageScripts from './pages/profile';
import {
    Header,
    Form
} from "./pages/headerAndForms";
import Tech from './pages/tech';
import MagicWall from './pages/magicWall'

(function($){
    $.fn.disableSelection = function() {
        return this
            .attr('unselectable', 'on')
            .css('user-select', 'none')
            .on('selectstart', false);
    };
})(jQuery);

$(document).ready(() => {
    studioScripts();
    let snowQueen = new SnowQueen();
    let teacher = new Teacher();
    let teacherList = new TeacherList();
    let listSeminars = new ListSeminars();
    contactScripts();
    let seminar = new Seminar();
    let header = new Header();
    let form = new Form();
    let tech = new Tech();
    let mw = new MagicWall();
    profilePageScripts();


    $('.innerWindow button').on('click', function () {
        $('.payBackPopUp').fadeOut(100);
    });

    $("header > .links a[href^='/contacts/'], .contacts_list").hover(function() {
        $(this).parents('.main-wrapper').find(".contacts_list").show();
    }, function() {
        $(this).parents('.main-wrapper').find(".contacts_list").hide();
    });

});

$(window).on('load', () => {
    let myCl = window.location.hash.length === 0 ? 'kyiv' : window.location.hash.substr(1);
    let $myCl = $(`#${myCl}`);

    if($myCl.length > 0)
        $myCl.click();
});

// dom 4 polyfill
(function(ELEMENT) {
    ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
    ELEMENT.closest = ELEMENT.closest || function closest(selector) {
        if (!this) return null;
        if (this.matches(selector)) return this;
        if (!this.parentElement) {return null}
        else return this.parentElement.closest(selector)
    };
}(Element.prototype));

// common.js
function clearForm(this_form) {

    var i;
    for (i = 0; i < this_form.length; i++) {

        if (this_form.elements[i].type == 'submit' || this_form.elements[i].type == 'hidden') continue;
        this_form.elements[i].value = "";
    }

}

function sendGA() {
    try {
        dataLayer.push({
            'event': 'event-to-ga',
            'eventCategory': 'form',
            'eventAction': 'zapis'
        });
        dataLayer = [];
    } catch (e) {
        console.log('GA error', e);
    }
}

String.prototype.hashCode = function(){
    var hash = 0;
    if (this.length == 0) return hash;
    for (var i = 0; i < this.length; i++) {
        var char = this.charCodeAt(i);
        hash = ((hash<<5)-hash)+char;
        hash = hash & hash;
    }
    return hash;
};

function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

(function (obj, w) {

    var elem,
        form,
        hideClass = 'hide';


    Element.prototype.hide = function () {
        this.classList.add(hideClass);
    };

    Element.prototype.show = function () {
        this.classList.remove(hideClass);
    };
    var formData = Object.create({});
    formData.get  = function (name) {
        return this[name];
    };


    obj.step = 1;
    obj.sex = 1;
    obj.dataToSend = {};
    obj.waiting_request = false;


    obj.validation = function () {
        var error = 0;
        // $('.go_send_form.form_inner_button').css('pointer-events', 'none');
        this.inputNameRequired = ['fio', 'fiolname', 'person_sex', 'type_hair', 'hairPhoto[]'];
        this.inputNameCheckBoxRequired = [' license_tern', 'hairSedina', 'hairLength'];


        if (this.step == 1) {
            this.inputNameRequired = this.inputNameRequired.slice(0, 2);

        } else {

            if (this.sex == 2) {
                this.inputNameCheckBoxRequired = this.inputNameCheckBoxRequired.slice(0, 2);
            }

            //checkbox
            this.inputNameCheckBoxRequired.forEach(function (checkBoxName) {

                var check = form.querySelectorAll('input[name=' + checkBoxName + ']');
                if (!form.querySelector('input[name=' + checkBoxName + ']:checked')) {
                    error++;
                    Array.prototype.slice.call(check, 0).forEach(function (redio) {
                        redio.classList.add('radioError');
                    });
                } else {
                    Array.prototype.slice.call(check, 0).forEach(function (redio) {
                        redio.classList.remove('radioError');
                    });
                }
            })
        }


        if (elem.tel.value.length < 19 || elem.tel.value[18] === '_') {
            elem.tel.className = " errorInput";
            error++;
        } else {
            elem.tel.classList.remove('errorInput');
        }

        if (elem.eml.value.length > 0) {
            if (!elem.eml.value.match(/[0-9a-z_]+@[0-9a-z_-]+\.[a-z]+/i)) {
                elem.eml.className = " errorInput";
                error++;
            } else {
                elem.eml.classList.remove('errorInput');
            }
        } else {
            elem.eml.classList.remove('errorInput');
        }


        for (var i = 0; i < elem.length; i++) {

            this.dataToSend[elem[i].name] = elem[i].value;

            if (this.inputNameRequired.indexOf(elem[i].name) < 0) continue;

            if (!elem[i].value) {


                elem[i].className = " errorInput";
                error++;
            } else {

                elem[i].classList.remove('errorInput');

            }

            if (elem[i].name == 'hairPhoto[]') {
                if (!form.querySelectorAll('.uploaded_images .img').length) {
                    elem[i].parentNode.classList.add('errorInput');
                } else {
                    elem[i].parentNode.classList.remove('errorInput');
                }
            }

        }

        return error ? !1 : !0;

    };


    obj.sentToServer = function () {
        var $loader = $('<div class="form_loader"></div>');
        $(form).append($loader);
        var data_to_form = this.entryData();

        var promocode = (typeof data_to_form === 'object' && data_to_form.get('bf-promocode')) || $(form).find('input[name="promo"]').val();
        var objToSend = {
            fio: data_to_form.get('fio'),
            tel: data_to_form.get('tel'),
            seminar: data_to_form.get('seminar'),
            iblock_id_course: data_to_form.get('iblock_id_course'),
            course: data_to_form.get('course'),
            contacts: data_to_form.get('contacts'),
            cours_form: data_to_form.get('cours_form'),
            type_person: data_to_form.get('type_person'),
            feed: data_to_form.get('feed'),
            send_sms: 1
        };

        if (data_to_form.get('friend'))
            objToSend.friend = data_to_form.get('friend');

         data_to_form.type =  "registration";

        $.ajax({
            url: location.href,
            type: 'POST',
            data: JSON.stringify(data_to_form),
            success: function (response) {
                if (response.trim().length == 0) {
                    $(form).next().find('.thx_pay').hide();
                }

                $(form).find('.form_loader').remove();
                $(form).next().append(response);

                if (objToSend.friend && objToSend.friend.length > 0) {
                    let payUrl = $(form).next().find('.form_to_pay').attr("href");
                    if(payUrl)
                        location.href = payUrl;

                    return;
                }

                if ((promocode && promocode.hashCode() === -1102485227) && data_to_form.get('type_person') ==="master")
                    $(form).next().find('.form_to_pay').submit();
                else if ((promocode && promocode.toLowerCase() === "f+1") && data_to_form.get('type_person') === "master" && !data_to_form.get('except')) {
                    $(form).find('input').each(function (i,e) {
                        if (e.getAttribute("type") !== "hidden")
                            e.value = "";
                    });
                    $(form).find(".form_body").append('<input name="friend" value="'+response+'" type="hidden">');
                    $(form).find('.go_send_form.form_inner_button').text("Записати друга").css("pointer-events", "cursor");
                    $(form).find('.field-half-block').addClass("hide");
                    $(form).find('.form_head--header').text("Записатися на семінар");
                    $(form).find('input[name="promo"]').parent().addClass("hide");
                } else {
                    $(form).hide();
                    $(form).next().removeClass("hide").addClass("show");
                }

                sendGA();

                // $.post('/ajax/feedback.php', objToSend);

            },
            cache: false,
            contentType: false,
            processData: false,
            headers: {
                "x-csfr-token": data_to_form.get('x-csrf-token')
             }
        });

        this.step = 1;
        this.sex = 1;
    };

    obj.submit = function (DOMform) {
        form = DOMform;
        elem = form.elements;


        if (this.validation()) {
            this.sentToServer();
        } else {
            $('.go_send_form.form_inner_button').css('pointer-events', '');
        }
    };

    obj.loadContent = function () {
        $('select[id^="type_person"]').on('change', function () {
            var first_step = $(this).parents('.first_step_record');
            var parent_form = $(this).parents('form');

            if ($(this).val() == 'model') {
                if ($(parent_form).hasClass('two_steps')) {
                    first_step.find(".go_form").removeClass('hide');
                    first_step.find(".go_send_form").addClass('hide');
                }


            } else {
                if ($(parent_form).hasClass('two_steps')) {
                    first_step.find(".go_form").addClass('hide');
                    first_step.find(".go_send_form").removeClass('hide');
                }
            }
        });


        $('#personSex').on('change', function (e) {
            var second_step = $(e.target).parents('.second_step_record');

            if (parseInt($(e.target).val()) == 2) {
                second_step[0].querySelector('#hair_color').hide();
                second_step[0].querySelector('#hair_length').hide();
                this.sex = 2;
            } else {
                second_step[0].querySelector('#hair_color').show();
                second_step[0].querySelector('#hair_length').show();
                this.sex = 1;
            }
        }.bind(this));

        let abonement =  new Abonement(this);

    };

    obj.events_init = function () {
        w.main_form = this;
        document.addEventListener('DOMContentLoaded', this.loadContent.bind(this));
    };

    obj.entryData  = function () {
        var elem = form.elements;
        var elemArray = Object.create(formData);
        for (var i = 0; i < elem.length; i++) {
            if(!elem[i].name) continue;

            elemArray[elem[i].name] = elem[i].type === 'checkbox' ? elem[i].checked : elem[i].value;
        }
        return elemArray;
    };
    // move
    obj.next = function (form) {
        elem = form.elements;
        if (this.validation()) {
            form.querySelector('.first_step_record').hide();
            form.querySelector('.second_step_record').show();
            this.step = 2;
        }

    };

    obj.prev = function (form) {
        form.querySelector('.first_step_record').show();
        form.querySelector('.second_step_record').hide();
        this.step = 1;
    };


    return obj;

})(Object.create({}), window).events_init();

(function (obj) {
    // FORM POPUP

    obj.dataToSend = {};

    obj.inputNameRequired = ['username', 'text'];

    obj.events_init = function () {
        document.addEventListener('DOMContentLoaded', this.hendler_submit.bind(this));
    }

    obj.validation = function (form) {

        var elem = form.elements, error = 0;

        if (elem.tel.value.length < 19 || elem.tel.value[18] === '_') {
            elem.tel.className = " errorInput";
            error++;
        } else {
            elem.tel.classList.remove('errorInput');
        }

        for (var i = 0; i < elem.length; i++) {

            this.dataToSend[elem[i].name] = elem[i].value;

            if (this.inputNameRequired.indexOf(elem[i].name) < 0) continue;

            if (!elem[i].value) {
                elem[i].className = " errorInput";
                error++;
            } else {
                elem[i].classList.remove('errorInput');

            }
        }

        return error ? !1 : !0;
    }

    obj.submit = function (e) {

        e.preventDefault();

        if (this.validation(this.form)) {
            this.sentToServer();
            this.done();
        }

    }

    obj.done = function () {
        $('.innerWindow.inputForm').fadeOut(100);
        $('.innerWindow.thxPage').fadeIn(200);
        $('.innerWindow.thxPage button').on('click', function () {
            $('.callBackPopUp').fadeOut(100);
            $('.innerWindow.thxPage').hide(50);
            $('.innerWindow.inputForm').show(50);
            $('#closeForm').trigger('click');
        })
    }

    obj.sentToServer = function () {
        sendGA();

        $.post("/ajax/feedback_call.php", this.dataToSend, function (data) {
            if (data.trim().length > 0) {
                clearForm(obj.form);
            } else {
                alert("Error");
            }
        });
    }

    obj.hendler_submit = function () {

        this.form = document.getElementById('callBackForm');
        this.form.elements[this.form.elements.length - 1].addEventListener('click', this.submit.bind(this));


        $('#callBackButton, .js-saloon-callback').on('click', function (e) {
            var txt1 = 'Залиште, будь ласка, Ваш номер телефону. Ми зв\'яжемося з вами найближчим часом.',
                txt2 = 'Залиште ваші контактні дані і наш консультант зв\'яжеться з вами',
                header_txt1 = 'Замовити семінар <br> в салон',
                header_txt2 = 'Форма зворотнього зв\'язку';

            var windowWidth = $(window).width();
            var currPopup = $('.callBackPopUp');
            var curForm = $('.callBackPopUp form');
            var curName = $(curForm).find('input[id^="userName"]');
            var curPhone = $(curForm).find('input[id^="userPhone"]');
            var userText = $(curForm).find('textarea[id^="userText"]').length > 0 ? $(curForm).find('textarea[id^="userText"]').val().length : 1;
            // var curEmail = $(curForm).find('input[class^="select_city"]');

            var type = $(e.currentTarget).hasClass('js-saloon-callback');
            var input = '<input class="js-callback-input-studio" type="hidden" name="studio" value="1">';
            var inputUrl = '<input class="js-callback-input-url-studio" type="hidden" name="link" value="'+window.location.href+'">';
            var cmnt = '<fieldset class="js-callBack-cmnt">\n' +
                '          <textarea id="userText" name="text" cols="30" rows="1" autocomplete="off" required></textarea>\n' +
                '          <label for="userText">Ваше питання</label>\n' +
                '       </fieldset>';

            currPopup.find('.js-callback-input-url-studio').remove();

            if ($(e.currentTarget).hasClass('seminar-callback-btn') && currPopup.find('.js-callback-input-url-studio').length === 0)
                $(inputUrl).insertAfter(currPopup.find('.select_city'));
            else
                currPopup.find('.js-callback-input-url-studio').remove();

            if (type) {
                currPopup.find('.js-callBack-header').addClass('noimg');
                currPopup.find('.js-callBack-header').find('p').html(header_txt1);
                currPopup.find('.js-callBack-text').html(txt1);
                currPopup.find('.js-callBack-cmnt').remove();
                if (currPopup.find('.js-callback-input-studio').length === 0)
                    $(input).insertAfter(currPopup.find('.select_city'));
            } else {
                currPopup.find('.js-callBack-header').removeClass('noimg');
                currPopup.find('.js-callBack-header').find('p').html(header_txt2);
                currPopup.find('.js-callBack-text').html(txt2);
                $(cmnt).insertAfter(currPopup.find('.select_city'));
                currPopup.find('.js-callback-input-studio').remove();
            }

            $(curForm).on('keyup change blur', function () {
                if (curName.val().length > 0 && (curPhone.val().length > 0 && curPhone.val()[18] !== '_' && userText > 0)) {
                    $(curForm).find('button').addClass('fullForm');
                } else {
                    $(curForm).find('button').removeClass('fullForm');
                }
            });
            $('.callBackPopUp').fadeIn(200);
            if (windowWidth < 768) {
                $('.container_wrapper, header').css('display', 'none');
            }
            $('#closeForm').on('click', function () {
                $('.callBackPopUp').fadeOut(200);
                if (windowWidth < 768) {
                    $('.container_wrapper, header').css('display', 'flex');
                }
            });

            $('body').on('click', function (ev) {
                if ($(ev.target).closest(".callBackPopUp .bg").length == 1) $(".callBackPopUp").fadeOut(300);
            });
        })


    }

    return obj;

})(Object.create({})).events_init();


(function (obj) {
    // FORM POPUP

    obj.dataToSend = {};

    obj.inputNameRequired = ['username'];

    obj.events_init = function () {
        document.addEventListener('DOMContentLoaded', this.hendler_submit.bind(this));
    }

    obj.validation = function (form) {

        var elem = form.elements, error = 0;

        if (elem.tel.value.length < 19 || elem.tel.value[18] === '_') {
            elem.tel.className = " errorInput";
            error++;
        } else {
            elem.tel.classList.remove('errorInput');
        }


        if (elem.eml.value.length > 0) {
            if (!elem.eml.value.match(/[0-9a-z_]+@[0-9a-z_-]+\.[a-z]+/i)) {
                elem.eml.className = " errorInput";
                error++;
            } else {
                elem.eml.classList.remove('errorInput');
            }
        } else {
            elem.eml.classList.remove('errorInput');
        }

        for (var i = 0; i < elem.length; i++) {

            this.dataToSend[elem[i].name] = elem[i].value;

            if (this.inputNameRequired.indexOf(elem[i].name) < 0) continue;

            if (!elem[i].value) {
                elem[i].className = " errorInput";
                error++;
            } else {
                elem[i].classList.remove('errorInput');

            }
        }

        return error ? !1 : !0;

    }

    obj.submit = function (e) {

        e.preventDefault();

        if (this.validation(this.form)) {
            this.sentToServer();
            this.done(this.form);
        }

    }

    obj.done = function (form) {
        $(form).hide();
        $(form).next().removeClass("hide").addClass("show");
    }

    obj.sentToServer = function () {
        sendGA();
        $.post("/ajax/feedback_empty.php", this.dataToSend, function (data) {
            if (data.trim().length > 0) {
                clearForm(obj.form);
            } else {
                alert("Error");
            }
        });
    }

    obj.hendler_submit = function () {

        this.form = document.getElementById('emptyCallBackForm');

        if (!this.form) return false;

        this.form.elements[this.form.elements.length - 1].addEventListener('click', this.submit.bind(this));

    }

    return obj;

})(Object.create({})).events_init();

document.addEventListener('DOMContentLoaded', checkerEmptyForm);
document.addEventListener('DOMContentLoaded', generationPDF);


function generationPDF() {

    //PDF download
    var download_a = document.querySelectorAll('.download_all a');


    function Eventhedler(event) {

        event.target.parentNode.classList.add("locked");

        $.get(location.origin + "/generation_pdf_estel/", {TOWN: location.href}, function (data) {
            if (data.trim().length > 0) {

                event.target.parentNode.classList.remove("locked");

                var load = document.createElement('a');
                load.setAttribute('download', "");
                load.setAttribute('href', data);
                document.body.appendChild(load);
                load.click();
                load.remove();

            }
            else {
                alert("Error");
            }
        });

        event.preventDefault();
    }

    if (download_a.length > 0) {
        for (var i = 0; i < download_a.length; i++) {
            download_a[i].addEventListener('click', Eventhedler);
        }
    }


}

function checkerEmptyForm() {

    //TODO переделать

    $("input[id^='userPhone']").mask("+38 (099) 999-99-99", {autoclear: false});


    $.fn.onlyLetters = function () {
        return this.each(function () {
            $(this).on('keydown', function (e) {
                var key = e.charCode || e.keyCode || 0;

                return ( (key >= 0 && key <= 47) || (key >= 58 && key <= 94) || key >= 106 );
            });
        });
    };
    $('input[id^="userName"]').onlyLetters();

    $('form.form-label').each(function () {
        var curForm = $(this);
        var curName = $(curForm).find('input[id^="userName"]');
        var curPhone = $(curForm).find('input[id^="userPhone"]');
        var curDate = $(curForm).find('.select_date select');
        $(curForm).on('keyup change blur', function () {
            if (curName.val().length > 0 && (curPhone.val().length > 0 && curPhone.val()[18] !== '_')) {
                $(curForm).find('button').addClass('fullForm');
            } else {
                $(curForm).find('button').removeClass('fullForm');
            }
        });

        var numbersOfSeminars = $(curDate).find('option').length;
        if (numbersOfSeminars > 1) {
            $('.select_date select').removeClass('oneSelect');
        } else {
            $('.select_date select').addClass('oneSelect');
        }
    });
}

// HELPERS

//Добавление файлов в загрузку
//todo ограничение в 1мб и тип и количество

$(document).ready(function () {

    //формЫ !!!
    $('.queen_reg_form_popup span.close_popup').on('click', function () {
        $('.queen_reg_form_popup').hide();
        $('.queen_reg_form_popup .second_step, .queen_reg_form_popup .first_step, .queen_reg_form_popup .thx_second_step, .queen_reg_form_popup .thx_first_step').addClass('hide');
        if ($(window).width() > 768) {
            $('body').css({'max-height': '', 'overflow': ''});

        } else {
            $('#snow_queen, footer, header').css('display', '');

        }
    });
    $('#snow_queen p#reg_form, #snow_queen .open_first, .queen_reg_form_popup .open_first').on('click', function () {
        $('.queen_reg_form_popup').show();
        $('.queen_reg_form_popup .first_step').removeClass('hide');
        $('.queen_reg_form_popup .second_step').addClass('hide');
        if ($(window).width() > 768) {
            $('body').css({'max-height': '100vh', 'overflow': 'hidden'});

        } else {
            $('#snow_queen, footer, header').css('display', 'none');
        }


    });
    $('#snow_queen #description_form, #snow_queen .open_second, .queen_reg_form_popup .open_second').on('click', function (e) {
        e.preventDefault();
        $('.queen_reg_form_popup').show();
        $('.queen_reg_form_popup .first_step').addClass('hide');
        $('.queen_reg_form_popup .second_step').removeClass('hide');
        if ($(window).width() > 768) {
            $('body').css({'max-height': '100vh', 'overflow': 'hidden'});

        } else {
            $('#snow_queen, footer, header').css('display', 'none');
        }

    });

    //Выбор области
    $(function () {
        $('#region_ua').on('change', function (e) {
            e.preventDefault();
            var obj;
            var select = $(this);
            var val = select.val();
            $.ajax({
                type: "GET",
                url: /sq/,
                dataType: 'json',
                data: {regionId: val, method: "cities"}
            }).done(function (response) {
                // console.log(response);
                $('#city_ua').text('<option value="default" selected disabled></option>');
                $('#education_ua').text('<option value="default" selected disabled></option>');
                var citys = response.data.city;
                var nom = response.data.nomination;
                $('#city_ua').append('<option selected disabled value="default"></option>')
                for (var i = 0; i < citys.length; i++) {
                    $('#city_ua').append('<option value=' + citys[i].UF_XML_ID + '>' + citys[i].UF_NAME + '</option>')
                }
                $('.nomination input').val(nom.UF_NAME);
                $('input[name="nomination"]').val(nom.UF_XML_ID);
            }).fail(function () {
                console.log('fail');
                alert('error')
            }).always(function () {

            });
            // e.preventDefault();
        });
    });

    //Выбор города
    $(function () {
        $('#city_ua').on('change', function (e) {
            e.preventDefault();
            var obj;
            var select = $(this);
            var val = select.val();
            $.ajax({
                type: "GET",
                url: /sq/,
                dataType: 'json',
                data: {cityId: val, method: "educationalSchools"}
            }).done(function (response) {
                // console.log(response);
                $('#education_ua').text('<option selected disabled value="default"></option>');
                var edu = response.data;
                $('#education_ua').append('<option selected disabled value="default"></option>')
                for (var i = 0; i < edu.length; i++) {
                    $('#education_ua').append('<option value=' + edu[i].UF_XML_ID + '>' + edu[i].UF_NAME + '</option>')
                }
            }).fail(function () {
                console.log('fail');
                alert('error')
            }).always(function () {

            });
            // e.preventDefault();
        });
    });

    //Обязательные поля формы регистрации
    $(function () {

        function setVisibleToForm(dataToSend, files, container) {
            try {
                dataToSend.delete('fileUpload[]');
            } catch (e) {
            }
            for (var i = 0, img; img = container.querySelectorAll('.img')[i]; i++) {
                if (files[img.dataset.filename])
                    dataToSend.append('fileUpload[]', files[img.dataset.filename], img.dataset.filename);

            }
            return dataToSend;
        }

        var formItSelf = $('#registration_form_sq'), fileToload = {}, $container = formItSelf.find('.uploaded_images');

        // Загрузка файлов
        window.previewFile = function (input) {
            var fileTypes = ['jpg', 'jpeg', 'png', 'jfif', 'jif'];
            var fileSizeLimit = 2000000;
            var files = input.files;
            var counter = 0;
            var itemsLength = $container[0].querySelectorAll('.img').length;


            if (itemsLength === 3 && files.length >= 3) {
                $container.empty();
            } else if (itemsLength > 0 && itemsLength <= 3 && files.length > (3 - itemsLength)) {
                var freeSpace = 3 - itemsLength;
                var addFiles = files.length > 3 ? 3 : files.length;
                $container.find('.img:lt(' + (addFiles - freeSpace) + ')').remove();
            }
            (function readFile() {
                var file = files[counter];


                if (typeof file !== 'undefined') {
                    fileToload[file.name] = file;

                    //check file type
                    var extension = file.name.split('.').pop().toLowerCase(),
                        isSuccessType = fileTypes.indexOf(extension) > -1;

                    if (!isSuccessType) return;

                    // check file size
                    if (file.size > fileSizeLimit) {
                        $container.prev().find('span.file_error_size').removeClass('hide');
                        $container.prev().find('span.file_error').addClass('hide');
                        return
                    }

                    var $template = $(
                        '<div id="img_wrap_' + counter + '" class="img" data-filename="' + file.name + '" style="display: inline-block;">' +
                        '<div class="remove" ></div>' +
                        '<div class="img_wp" ></div>' +
                        '<span class="file_title">' + file.name.slice(0, 7) + '</span>' +
                        '</div>');
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        $template.find('.img_wp').css('background-image', 'url("' + reader.result + '")');
                        $container.append($template);
                        itemsLength = $container[0].querySelectorAll('.img').length;
                        $container.prev().find('span.file_error').addClass('hide');
                        $container.prev().find('span.file_error_size').addClass('hide');
                    };
                    if (file) {
                        reader.readAsDataURL(file);
                        counter++;
                        if (counter <= 2) readFile();
                    }
                }


            })();


            $(document).on('click', '.remove', function () {
                if ($(this).closest('.img')) {
                    $(this).closest('.img').remove();

                    if (!$container[0].querySelectorAll('.img').length) {
                        $container.prev().find('span.file_error').removeClass('hide');
                    }

                    // upload_button[0].style.display = 'inline-block';
                }
            });
        }

        //Todo Подсветка кнопки
        $('#registration_form_sq').on('keyup change blur', function () {

            var fields = $(formItSelf).find('fieldset');
            var checkAll;
            for (var i = 0; i < fields.length; i++) {
                checkAll = true;
                var one_field = fields[i];
                var one_input = $(one_field).find('input');
                if  (!$(one_input).is('#comments')) {
                    if ($(one_input).val() == "") {
                        $(formItSelf).find('input[type="submit"]').removeClass('form_complete');
                        checkAll = false;
                        break;
                    }
                }
            }
            if (checkAll) {
                $(formItSelf).find('input[type="submit"]').addClass('form_complete');
            }
        });
        $('#registration_form_sq input[type="submit"]').on('click', function (e) {


            e.preventDefault();


            var telInput = $(formItSelf).find('input[type="tel"]');
            var emlInput = $(formItSelf).find('input[name="email"]');
            var fileInput = $(formItSelf).find('input.fileUpload');
            var comments = $(formItSelf).find('#comments');
            var studyPlace = $(formItSelf).find('#education_ua');
            var obj = {};
            var error = false;
            $('fieldset input, fieldset select, label').removeClass('errorInput');

            //проверка на пустые поля
            $(formItSelf).find('fieldset').each(function () {
                var oneInput = $(this).find('input');
                var oneSelect = $(this).find('select');
                if (oneInput.length && $(oneInput).val() == "") {
                    $(oneInput).addClass('errorInput');
                    if  (!$(oneInput).is('#comments')) {
                        error = true;
                    }
                }
                if (oneSelect.length && ($(oneSelect).val() == "" || $(oneSelect).val() == "default" || $(oneSelect).val() == undefined)) {
                    $(oneSelect).addClass('errorInput');
                    if  (!$(oneSelect).is('#education_ua')) {
                        error = true;
                    }
                }
            })
            //проверка на не отмеченные чекбоксы
            $(formItSelf).find('.checkboxes').each(function () {
                if (!$(this).find('input[type="checkbox"]').is(':checked')) {
                    $(this).find('label').addClass('errorInput');
                    error = true;
                }
            });
            // Валидация email
            if (!$(emlInput).val().match(/[0-9a-z_]+@[0-9a-z_-]+\.[a-z]+/i)) {
                $(emlInput).addClass('errorInput');
                error = true;
            } else {
                $(emlInput).removeClass('errorInput');
                // error = false;
            }
            // Валидация номера телефона
            if ($(telInput).val().length < 19 || $(telInput).val()[18] === '_') {
                $(telInput).addClass('errorInput');
                error = true;
            } else {
                $(telInput).removeClass('errorInput');
                // error = false;
            }

            // Валидация  ФАЙЛА
            if ($(fileInput).val() == '' || !$container[0].querySelectorAll('.img').length) {
                $(fileInput).addClass('errorInput');
                $('span.file_error').removeClass('hide');
                $('span.file_error_size').addClass('hide');
                error = true;
            } else {
                $(fileInput).removeClass('errorInput');
                $('span.file_error, span.file_error_size').addClass('hide');
                // error = false;
            }

            //либо место либо коммент
            if ($(comments).val() != "" || ($(studyPlace).val() == "" || $(studyPlace).val() == "default" || $(studyPlace).val() != undefined || $(studyPlace).val() != null)) {
                $(comments).removeClass('errorInput');
                $(studyPlace).removeClass('errorInput');
                // error = false;
            }
            //отправка формы реигстрации
            if (!error) {


                var fomdataTosend = new FormData(formItSelf[0]);
                if (!$(this).hasClass('form_complete')) return false;
                $(formItSelf).find('input[type="submit"]').removeClass('form_complete');
                $(formItSelf).find('input[type="submit"]').css('pointer-events','none');
                $.ajax({
                    type: "POST",
                    url: /sq/,
                    data: setVisibleToForm(fomdataTosend, fileToload, $container[0]),
                    cache: false,
                    contentType: false,
                    processData: false
                }).done(function (data) {
                    console.log('success');
                    if (data) {
                        $('.queen_reg_form_popup .first_step').addClass('hide');
                        $('.queen_reg_form_popup .thx_first_step').removeClass('hide');
                        formItSelf[0].reset();
                        $('#city_ua').text('');
                        $('#education_ua').text('');
                        $('.nomination input').val('');
                        $('.uploaded_images').text('');
                        $(formItSelf).find('input[type="submit"]').css('pointer-events','');
                    }
                }).fail(function () {
                    console.log('fail');
                    alert('error')
                }).always(function () {

                });
            } else {
                //Скролл на первое неправильное поле
                var errors = formItSelf[0].querySelectorAll('.errorInput');
                var firstError = errors[0];
                $(firstError).get(0).scrollIntoView();

            }
        });
    });


    //Обязательные поля формы техЛиста
    $(function () {
        //Проверка номера
        var delay = (function () {
            var timer = 0;
            return function (callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        })();
        var errorNumber = false;
        $('#record_number').on('keyup paste', function (num) {
            delay(function () {
                var select = $(num.target);
                var val = select.val();
                $.ajax({
                    type: "POST",
                    url: /sq/,
                    dataType: 'json',
                    data: {codeId: val, method: "chackExistUserCode"}
                }).done(function (response) {
                    console.log(response);
                    if (response.status == "ok") {
                        $('.no_such_number, .already_have_number').addClass('hide');
                        errorNumber = false;
                    } else if (response.status == "already") {
                        $('.already_have_number').removeClass('hide');
                        $('.no_such_number').addClass('hide');
                        errorNumber = true;
                    } else {
                        $('.no_such_number').removeClass('hide');
                        $('.already_have_number').addClass('hide');
                        errorNumber = true;
                    }
                }).fail(function () {
                    console.log('fail');
                }).always(function () {

                });
            }, 1000);
        });
        //Todo Подсветка кнопки
        $('#tech_form_sq').on('keyup change blur', function () {
            var formItSelf = $(this);
            var fields = $(formItSelf).find('fieldset');
            var checkAll;
            for (var i = 0; i < fields.length; i++) {
                checkAll = true;
                var one_field = fields[i];
                var one_input = $(one_field).find('input');
                if ($(one_input).val() == "") {
                    $(formItSelf).find('input[type="submit"]').removeClass('form_complete');
                    checkAll = false;
                    break;
                }
            }
            if (checkAll) {
                $(formItSelf).find('input[type="submit"]').addClass('form_complete');
            }
        });
        $('#tech_form_sq input[type="submit"]').on('click', function (e) {
            e.preventDefault();


            var formItSelf = $(this).parents('form');
            var error = false;
            $('fieldset input, fieldset select, label, #record_number').removeClass('errorInput');

            if (errorNumber || ($('#record_number').val() == "")) {
                $('#record_number').addClass('errorInput');
                error = true;
            }
            //проверка на пустые поля
            $(formItSelf).find('fieldset').each(function () {
                var oneInput = $(this).find('input');
                if ($(oneInput).val() == "") {
                    $(oneInput).addClass('errorInput');
                    error = true;
                }
            })
            //проверка на не отмеченные radiobutts
            var radioButs = $(formItSelf).find('.checkboxes');
            var checkedRadion = false;
            for (var i = 0; i < radioButs.length; i++) {
                var oneRad = radioButs[i];
                if ($(oneRad).find('input[type="radio"]').is(':checked')) {
                    checkedRadion = true;
                    // error = false;
                    break;
                } else {
                    $(oneRad).find('label').addClass('errorInput');
                }
            }
            if (checkedRadion) {
                $(formItSelf).find('label').removeClass('errorInput')
            } else {
                error = true;

            }

            //отправка формы реигстрации
            if (!error) {
                if (!$(this).hasClass('form_complete')) return false;
                $(formItSelf).find('input[type="submit"]').removeClass('form_complete');


                $.ajax({
                    type: "POST",
                    url: /sq/,
                    data: new FormData(formItSelf[0]),
                    cache: false,
                    contentType: false,
                    processData: false
                }).done(function (data) {
                    console.log('success');
                    if (data) {
                        $('.queen_reg_form_popup .second_step').addClass('hide');
                        $('.queen_reg_form_popup .thx_second_step').removeClass('hide');
                        formItSelf[0].reset();
                    }
                }).fail(function () {
                    console.log('fail');
                    alert('error')
                }).always(function () {

                });
            } else {
                //Скролл на первое неправильное поле
                var errors = formItSelf[0].querySelectorAll('.errorInput');
                var firstError = errors[0];
                $(firstError).get(0).scrollIntoView();
            }
        });
    });
    $.fn.onlyNumbers = function () {
        return this.each(function () {
            $(this).on('keydown', function (e) {
                var key = e.charCode || e.keyCode || 0;
                return (key >= 48 && key <= 57);
            });
        });
    };
    // $('input[id^="record_number"]').onlyNumbers();
    $("#birth_date").mask("?99/99/9999", {});
})